import { useMediaQuery, useTheme } from '@mui/material';

export const useMobile = () => {
	const theme = useTheme();
	return !useMediaQuery(theme.breakpoints.up('sm'));
};
